import React from 'react';
import AdminUserGroupListContainer from '@src/components/administration/AdminUserGroupListContainer';

const AdminUserGroupListPage = () => <AdminUserGroupListContainer />;

export default AdminUserGroupListPage as any;